import { useEffect, useRef } from 'react';

import { useFeatureFlags } from '../../crn-feature-flags';
import { State } from '/utils/reduxUserTypes';

/**
 * Updates the user's feature flag context anytime the user's ID changes
 * This should
 *
 */
export const useLoggedInUpdateUser = (user: State['user']) => {
	const idRef = useRef<number>();

	const { updateUser } = useFeatureFlags();

	useEffect(() => {
		async function update() {
			const orgFields = !user.supervisor
				? {}
				: {
						dptID: user.user_orgs?.[0]?.department_id,
						locID: user.user_orgs?.[0]?.location_id,
						orgID: user.user_orgs?.[0]?.organization_id
				  };

			await updateUser({
				actType: user.admin ? 'admin' : user.supervisor ? 'supervisor' : null,
				email: user.email,
				firstName: user.first_name,
				isTestUser: user.is_test_user,
				key: user.id.toString(),
				lastName: user.last_name,
				roleID: user.role_id,
				state: user.state,
				...orgFields
			});
		}

		if (user.id && user.id !== idRef.current) {
			idRef.current = user.id;
			update();
		}
	}, [user.id]);
};
